export interface IOrganizerSettings {
    allParticipantsActive: boolean;
    isPublic: boolean;
    allowRounds: boolean;
}

export const DEFAULT_ORGANIZER_SETTINGS: IOrganizerSettings = {
    allParticipantsActive: true,
    isPublic: true,
    allowRounds: false,
};

export interface IUser {
    userId: string;
    userName: string;
    email: string;
    name: string;
    portraitBlobAddressUri: string;
    picture?: string;
    webPage: string;
    comment: string;
    organizerSettings?: IOrganizerSettings;
}